import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import PageBase from '@components/pages/PageBase';
import SectionScheduler from '@components/pages/c006/SectionScheduler'
import { MdArrowBackIos } from "react-icons/md";


const SelectSchedulePage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const title = searchParams.get('title') ?? '';
    const handleBackIconClick = () => {
        navigate(-1)
    };
    const dispTitle = (
        <>
            <MdArrowBackIos style={{ verticalAlign: 'middle' }} onClick={handleBackIconClick} />
            {title}
        </>
    );

    return (
        <PageBase title={dispTitle}>
            <SectionScheduler />
        </PageBase>
    );
}


export default SelectSchedulePage;
